import React from 'react';
import { HyperText } from '../components/HyperText';
import { Grid } from '../components/ui/GridPattern';
const AboutPage = () => {
  return <div className="w-full min-h-screen bg-center bg-cover bg-no-repeat bg-gray-900" style={{
    backgroundImage: `url(https://uploadthingy.s3.us-west-1.amazonaws.com/ffKqJNNiYL1Zb2QGJWJVtf/BGBLUE.png)`
  }} data-id="element-293">
      <div className="pt-28 sm:pt-32 md:pt-40 pb-6 sm:pb-10" data-id="element-294">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal px-4" data-id="element-295">
          About Us
        </h1>
      </div>
      <div className="py-12 sm:py-16 md:py-24" data-id="element-296">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-297">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 mb-10 sm:mb-16" data-id="element-298">
            <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm overflow-hidden" data-id="element-299">
              <Grid size={20} data-id="element-300" />
              <div className="relative z-20" data-id="element-301">
                <h2 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-normal" data-id="element-302">
                  Mission
                </h2>
                <p className="text-base sm:text-lg md:text-xl text-gray-300 font-light" data-id="element-303">
                  To provide compassionate, personalized care by empowering
                  providers through innovation and integrity.
                </p>
              </div>
            </div>
            <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm overflow-hidden" data-id="element-304">
              <Grid size={20} data-id="element-305" />
              <div className="relative z-20" data-id="element-306">
                <h2 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-normal" data-id="element-307">
                  Vision
                </h2>
                <p className="text-base sm:text-lg md:text-xl text-gray-300 font-light" data-id="element-308">
                  To elevate care by setting new standards of excellence.
                </p>
              </div>
            </div>
          </div>
          <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm mb-10 sm:mb-16" data-id="element-309">
            <div data-id="element-310">
              <h2 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-8 text-center tracking-normal" data-id="element-311">
                Core Pillars
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-[#89CFF0] mb-6 sm:mb-8 text-center font-light" data-id="element-312">
                We Care about our commitments to the...
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-313">
                {corePillars.map((pillar, index) => <div key={index} className="bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 rounded-xl border border-gray-700 shadow-sm" data-id="element-314">
                    <h3 className="text-lg sm:text-xl font-light text-white mb-2 sm:mb-3 tracking-normal" data-id="element-315">
                      {pillar.title}
                    </h3>
                    <p className="text-sm sm:text-base text-gray-300 font-light" data-id="element-316">
                      {pillar.description}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const corePillars = [{
  title: 'Well-being of patients',
  description: 'We prioritize patient-centered care, ensuring comfort, dignity, and the highest quality of life.'
}, {
  title: 'Empowerment of team members',
  description: 'We foster an environment where our team can thrive professionally and personally.'
}, {
  title: 'Collaboration across the industry',
  description: 'We build meaningful partnerships to advance healthcare delivery and outcomes.'
}, {
  title: 'Accountability to stakeholders',
  description: 'We take responsibility for our actions and decisions, ensuring transparency and trust.'
}, {
  title: 'Responsibility of upholding integrity',
  description: 'We adhere to the highest ethical standards in all our operations and interactions.'
}, {
  title: 'Excellence of the highest of standards',
  description: 'We continuously strive to exceed expectations in every aspect of our service.'
}];
export default AboutPage;